// src/store/slices/otherDataSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  categoryOfInterest: [],
  membershipPositionForCommittee: [],
};

const otherDataSlice = createSlice({
  name: "otherData",
  initialState,
  reducers: {
    setOtherData: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { setOtherData } = otherDataSlice.actions;
export default otherDataSlice.reducer;
